import { VehiculoRepository } from '../../Domain/VehiculoRepository'
import { Matricula } from '../../Domain/Matricula'
import { Vehicle } from '../../../../../../common/types/Vehiculo'
import { getDevVehiculosPorMatricula } from '../dev/vehiculoMockFixtures'
import { isDevNeumaticosMockEnabled } from '../dev/neumaticosDevConfig'
import { VehiculoApiRepository } from './VehiculoApiRepository'

const MOCK_DELAY_MS = 600

export const VehiculoDevRepository: VehiculoRepository = {
  async obtenerPorMatricula(matricula: Matricula): Promise<Vehicle[] | null> {
    if (!isDevNeumaticosMockEnabled()) {
      return VehiculoApiRepository.obtenerPorMatricula(matricula)
    }

    const mock = getDevVehiculosPorMatricula(matricula.value())
    if (mock) {
      await new Promise((resolve) => setTimeout(resolve, MOCK_DELAY_MS))
      return mock
    }

    return VehiculoApiRepository.obtenerPorMatricula(matricula)
  },
}
